if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cart);
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        this.bundleErrorMessage = null;
        this.submitButton.setAttribute("disabled", true);
        this.submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          this.cart.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              return null;
            }

            // Add the "Product bundle" block selections in the same click, then
            // keep the freshest section markup so the cart shows every line.
            return this.addBundleItems(formData).then((bundleResponse) => {
              if (bundleResponse && bundleResponse.sections) {
                response.sections = bundleResponse.sections;
              }
              return response;
            });
          })
          .then((response) => {
            if (!response) {
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    if (this.cart) {
                      this.cart.renderContents(response);
                    }

                    if (this.cartItems) {
                      this.cartItems.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart) {
                this.cart.renderContents(response);
              }

              if (this.cartItems) {
                this.cartItems.renderContents(response);
              }
            }

            this.bundleUpsells.forEach((element) => element.reset?.());

            // Clear error message for THIS form instance, unless an add-on failed
            this.handleErrorMessage(this.bundleErrorMessage || false);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      /* "Product bundle" blocks bound to this form, if any are on the page. */
      get bundleUpsells() {
        if (this.closest("quick-add-modal")) return [];

        if (this.form && this.form.id) {
          const bound = document.querySelectorAll(
            `bundle-upsell[data-product-form-id="${this.form.id}"]`
          );
          if (bound.length) return Array.from(bound);
        }

        // The sticky add-to-cart bar posts its own form, so fall back to any
        // bundle rendered by the same product section.
        const scope =
          this.closest("product-info") || this.closest(".shopify-section");

        return scope ? Array.from(scope.querySelectorAll("bundle-upsell")) : [];
      }

      addBundleItems(formData) {
        const items = this.bundleUpsells.reduce(
          (all, element) => all.concat(element.selectedItems || []),
          []
        );

        if (!items.length) return Promise.resolve(null);

        const body = { items: items, sections_url: window.location.pathname };
        const sections = formData.getAll("sections").join(",");
        if (sections) body.sections = sections;

        const bundleConfig = fetchConfig();
        bundleConfig.headers["X-Requested-With"] = "XMLHttpRequest";
        bundleConfig.body = JSON.stringify(body);

        return fetch(`${routes.cart_add_url}.js`, bundleConfig)
          .then((response) => response.json())
          .then((response) => {
            if (response && response.status) {
              const message = response.description || response.message;
              console.error("Product bundle could not be added:", message);
              this.bundleErrorMessage = message;
              return null;
            }
            return response;
          })
          .catch((e) => {
            console.error(e);
            return null;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        
        // Exit early if no error wrapper found
        if (!this.errorMessageWrapper) {
          console.warn('Product form: Error message wrapper not found in DOM');
          return;
        }
          
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper?.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }

      toggleSubmitButton({ disable = true, text, isPreorder = false }) {
        this.bundleUpsells.forEach((element) => element.setDisabled?.(disable));

        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = isPreorder
            ? window.variantStrings.preorder
            : window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
